import ViewType from './ViewType';

export default ViewType;